import React, { useEffect } from "react";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Select, Checkbox, Row, Col, Button } from "antd";
import styles from "./styles.module.css";
import Link from "next/link";
// import ReCAPTCHA from "react-google-recaptcha";

import { messages } from "../../../../lib/vaildations";
import { useBrand } from "../../../../utils/brandContext";

const { Option } = Select;

const skills = ({
  form,
  skills,
  prevStep,
  registerWorker,
  hearAboutUs,
  admin,
  loading,
  data,
}) => {
  const brand = useBrand();
  const { getFieldDecorator, setFieldsValue } = form;
  useEffect(() => {
    setFieldsValue({
      ...data,
    });
  }, [data]);

  // const onChange = (checkedValues) => setSkills({...skillsAndHearAboutUs,skills:checkedValues});

  // const values = () => {
  //     console.log(checked)
  // }

  // const onSelectChange = value => setSkills({...skillsAndHearAboutUs, hearAboutUs: value});

  return (
    <div>
      <h2>What Skills Do You Currently Have?</h2>
      <Form.Item>
        {getFieldDecorator("skills", {
          rules: [{ required: true, message: messages.skillsLength }],
        })(
          <Checkbox.Group style={{ width: "100%" }}>
            <Row>
              {!skills.loading &&
                skills.data.skills.map((skill) => (
                  <Col md={8} sm={12} xs={24} key={skill.id}>
                    <Checkbox
                      className="sign-up-skills"
                      style={{ paddingTop: 5 }}
                      value={skill.sName}
                    >
                      {skill.name}
                    </Checkbox>
                  </Col>
                ))}
            </Row>
          </Checkbox.Group>
        )}
      </Form.Item>

      <h2>How Did You Hear About Us?</h2>
      <Form.Item>
        {getFieldDecorator("channel", {
          rules: [{ required: true, message: messages.required }],
        })(
          <Select
            showSearch
            placeholder="Please Select One Option"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {!hearAboutUs.loading &&
              hearAboutUs.data.channels.map((channel) => (
                <Option key={channel.id} value={channel.sName}>
                  {channel.name}
                </Option>
              ))}
          </Select>
        )}
      </Form.Item>
      {!admin && (
        <>
          <Form.Item>
            {getFieldDecorator("agreement", {
              valuePropName: "checked",
              rules: [
                {
                  validator: (rule, value, callback) => {
                    console.log(value);
                    if (!value) {
                      callback("Please agree the terms and conditions!");
                    } else {
                      callback();
                    }
                  },
                },
              ],
            })(
              <Checkbox>
                I Agree To The{" "}
                <a
                  href={
                    brand.WORKER_TERMS ?? "https://hapigig.com/user-agreement/"
                  }
                  target="_blank"
                >
                  Terms and Conditions
                </a>
              </Checkbox>
            )}
          </Form.Item>
        </>
      )}

      <div className={styles.ButtonsContainer}>
        <Button type="primary" onClick={prevStep}>
          Previous Step
        </Button>
        <Button
          style={{ marginLeft: 5 }}
          loading={loading}
          type="primary"
          onClick={registerWorker}
        >
          {admin
            ? "Add Worker"
            : `Become a ${brand.WORKER_TITLE ?? "HapiWorker"}`}
        </Button>
      </div>
    </div>
  );
};

export default skills;
